import { render, staticRenderFns } from "./GoalTypesForm.vue?vue&type=template&id=63735d2d&scoped=true&"
import script from "./GoalTypesForm.vue?vue&type=script&lang=js&"
export * from "./GoalTypesForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63735d2d",
  null
  
)

export default component.exports